var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "casino-page" },
    [
      _c(
        "v-layout",
        { staticClass: "page-layout" },
        [
          _c(
            "v-flex",
            {
              ref: "maincolumn",
              staticClass: "main-column",
              style: { paddingTop: _vm.headerHeight + "px" }
            },
            [
              _c("resize-observer", { on: { notify: _vm.mainColumnResize } }),
              _vm._v(" "),
              _c("div", { staticClass: "page-content casino" }, [
                _c(
                  "div",
                  {
                    staticClass: "casinopage",
                    class: [_vm.state, { loggedIn: _vm.isLoggedIn }]
                  },
                  [
                    _vm.geolocationMessage.errorCode === "verify" &&
                    _vm.onLoginGeolocationProgress &&
                    _vm.geolocationOnLogin &&
                    _vm.isLoggedIn &&
                    _vm.isGeoLocEnabled &&
                    !_vm.isOpenedFromWebView &&
                    !_vm.mobileBigAndBelow
                      ? _c(
                          "v-dialog",
                          {
                            attrs: { persistent: "" },
                            model: {
                              value: _vm.showGeolocationDialog,
                              callback: function($$v) {
                                _vm.showGeolocationDialog = $$v
                              },
                              expression: "showGeolocationDialog"
                            }
                          },
                          [
                            _vm.geolocationSubmitInternalError &&
                            _vm.geolocationSubmitInternalError.exceptionType &&
                            _vm.geolocationSubmitInternalError.exceptionType ===
                              "TechnicalException"
                              ? _c("div", {
                                  staticClass: "close-geolocation-dialog",
                                  on: {
                                    click: function($event) {
                                      return _vm.closeGeolocationDialog()
                                    }
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("geolocation-indicator")
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.geolocationMessage.errorCode !== "verify" &&
                    !_vm.geolocationStatus &&
                    _vm.isLoggedIn &&
                    _vm.isGeoLocEnabled &&
                    !_vm.isOpenedFromWebView &&
                    !_vm.mobileBigAndBelow
                      ? _c("geolocation-indicator", {
                          attrs: { section: "casino" }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.mobileBigAndBelow
                      ? _c("sports-menu-mobile", {
                          staticClass: "casino",
                          attrs: {
                            "casino-navigation-items": _vm.navigation,
                            "navigation-section": null
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("headlinesLight", {
                      attrs: {
                        category: "CasinoHeadlines",
                        tiles: _vm.headlineTiles
                      }
                    }),
                    _vm._v(" "),
                    _vm.tabletAndAbove
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "casino_links casino_nav left-column sports-menu"
                          },
                          [
                            _vm.navigation
                              ? _c("site-navigation", {
                                  staticClass:
                                    "popular expand navigation casino_links",
                                  attrs: {
                                    "casino-navigation-items": _vm.navigation,
                                    "navigation-section": null
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("router-view")
                  ],
                  1
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.casinoLauncherDialog ? _c("casino-launcher-dialog") : _vm._e(),
      _vm._v(" "),
      _vm.rtpPopup
        ? _c("div", { staticClass: "tandc-popup-container" }, [
            _c("div", { staticClass: "tandc-popup-child rtp-popup" }, [
              _c(
                "div",
                { staticClass: "tandc-popup-content rtp-popup" },
                [
                  _c("static-content", {
                    staticClass: "tc-text",
                    attrs: {
                      staticcontentpath:
                        "/static/static-content/" +
                        _vm.$i18n.locale +
                        "/RTP.html",
                      isPopUp: true,
                      fullPath: true,
                      method: "html"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-actions" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn primary-btn rtp",
                      on: {
                        click: function($event) {
                          return _vm.toggleRTP("close")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("Account.JoinUs.Popup.Close")))]
                  )
                ],
                1
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c3c9daf8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3c9daf8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/CasinoLayout.vue
// module id = null
// module chunks = 